import { useState } from 'react';

const GlassmorphismGenerator = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [response, setResponse] = useState('');

    const URl = "https://api.sheety.co/6f2e2dcbdd503bcc0d4921b30d20fa17/untitledSpreadsheet/sheet1";

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
      
        const response = await fetch('https://api.sheety.co/6f2e2dcbdd503bcc0d4921b30d20fa17/untitledSpreadsheet/sheet1', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            sheet1: {
              name: 'sunil',
              email: 'sunil@mgail.com',
            }
          }),
        });
      
        const result = await response.json();
        console.log(result);
      }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-400 via-pink-500 to-red-500 p-4">
            <div className="bg-white/10 backdrop-blur-md rounded-xl shadow-lg p-8 max-w-md w-full">
                <h2 className="text-2xl font-bold mb-6 text-white text-center">Glassmorphism Form</h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-white mb-2">Name:</label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            className="w-full p-2 rounded bg-white/30 backdrop-blur"
                            placeholder="Enter your name"
                        />
                    </div>

                    {/* <div>
                        <label className="block text-white mb-2">Email:</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full p-2 rounded bg-white/30 backdrop-blur"
                            placeholder="Enter your email"
                        />
                    </div> */}

                    <button
                        type="submit"
                        className="w-full bg-white/30 backdrop-blur hover:bg-white/40 text-white font-bold py-2 px-4 rounded"
                    >
                        Submit
                    </button>
                </form>

                {response && (
                    <p className="mt-6 text-center text-white">{response}</p>
                )}
            </div>
        </div>
    );
};

export default GlassmorphismGenerator;
